/**
 * لاگ‌گیری خطای سمت کلاینت.
 *
 * تاریخچه: نسخه‌ی اولیه کل شیء کاربر (شامل AccessToken/RefreshToken) را در
 * Firebase Realtime Database می‌نوشت. آن مسیر کاملاً حذف شد؛ حالا خطاها از طریق
 * `@/utils/monitoring` به endpoint داخلی POST /api/LogEvent می‌روند و همیشه در
 * کنسول هم چاپ می‌شوند.
 */

import { captureError } from "@/utils/monitoring";

const SENSITIVE_KEYS = [
    "accesstoken",
    "refreshtoken",
    "token",
    "password",
    "captchatoken",
    "authorization",
];

function isSensitive(key) {
    return SENSITIVE_KEYS.includes(String(key).toLowerCase());
}

/** یک خطا را به شیء ساده و بدون داده‌ی حساس تبدیل می‌کند. */
export function serializeError(err) {
    if (!err) return { message: "unknown" };
    if (typeof err === "string") return { message: err };
    try {
        const out = {
            name: err.name,
            message: err.message,
            stack:
                typeof err.stack === "string"
                    ? err.stack.split("\n").slice(0, 20).join("\n")
                    : undefined,
        };
        for (const k of Object.getOwnPropertyNames(err)) {
            if (["name", "message", "stack"].includes(k)) continue;
            if (isSensitive(k)) continue;
            const v = err[k];
            if (v == null || ["string", "number", "boolean"].includes(typeof v)) {
                out[k] = v;
            }
        }
        return out;
    } catch (e) {
        return { message: String(err) };
    }
}

/**
 * ثبت خطای کلاینت: reportClientError({ source, error, info?, userId? })
 * (اگر به‌اشتباه دو آرگومان داده شود، آرگومان دوم به‌عنوان payload گرفته می‌شود.)
 */
export function reportClientError(arg1, arg2) {
    const payload =
        arg2 && typeof arg2 === "object"
            ? arg2
            : arg1 && typeof arg1 === "object"
              ? arg1
              : {};

    const source = payload.source || "client";
    const raw = payload.error;

    // eslint-disable-next-line no-console
    console.error("[clientError]", source, (raw && raw.message) || raw);

    let error = raw;
    if (!(error instanceof Error)) {
        const s = serializeError(raw);
        error = new Error(s.message || "client error");
        error.name = s.name || "ClientError";
        if (s.stack) error.stack = s.stack;
    }

    try {
        captureError(error, {
            source,
            info: payload.info || undefined,
            userId: payload.userId || undefined,
            url:
                typeof location !== "undefined"
                    ? location.pathname + location.search
                    : undefined,
        });
    } catch (e) {
        /* noop */
    }
    return Promise.resolve();
}

export default { serializeError, reportClientError };
